var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{attrs:{"type":"text","id":_vm.name,"contenteditable":""},on:{"keyup":function($event){return _vm.onChange()}}},[_vm._v(_vm._s(_vm.fieldData))])])}
var staticRenderFns = []

export { render, staticRenderFns }